import React from "react";
import { svgData } from "../../constants/svg";
import { global_tailwind_constants } from "../../constants";

/**
 * Logo + centered column used by SSO screens.
 * @param {{children: React.ReactNode, hideLogo?: boolean, variant?: 'default' | 'success'}} props
 */
const AuthPageShell = ({ children, hideLogo = false, variant = "default" }) => (
  <div className={variant === "success" ? "auth-page--success" : undefined}>
    {!hideLogo ? (
      <header className={`flex flex-col items-center mb-6 ${variant === "success" ? "" : "mt-8"}`}>
        {svgData["form-logo"]()}
      </header>
    ) : null}
    <div className="flex justify-center px-4 pb-36">
      <div className={`${global_tailwind_constants.formWidth} w-full`}>
        {children}
      </div>
    </div>
  </div>
);

export default AuthPageShell;
